export function isABlankString(str) {
  if (str == null) {
    return true;
  }
  if (typeof str !== "string") {
    return false;
  }
  return str.length === 0 || str.trim().length === 0;
}
export function isNotABlankString(str) {
  return !isABlankString(str);
}
export function stringToList(str) {
  if (str != null) {
    return str.split(', ');
  }
  return [];
}
export function objToString(obj) {
  if (obj != null) {
    const keys = Object.keys(obj);
    let str = '';
    let first = true;
    for (let key of keys) {
      if (first === false) {
        str += ', ';
      }
      str += "".concat(key, ": ").concat(obj[key]);
      first = false;
    }
    return str;
  }
  return null;
}
export function stringToObj(str) {
  if (str != null) {
    let obj = {};

    // split values into key-value pairs
    const kvPairs = str.split(",");
    for (let pair of kvPairs) {
      // split key-value pairs into key and value
      let kv = pair.split(":");
      if (kv.length === 2) {
        let key = kv[0].trim();
        obj[key] = kv[1].trim();
      }
    }
    return obj;
  }
  return null;
}
export function listToString(list) {
  if (list != null && list.length > 0) {
    let str = '';
    let first = true;
    for (let s of list) {
      if (first === false) {
        str += ", ";
      }
      str += s;
      first = false;
    }
    return str;
  }
  return null;
}